import React, { createContext, useContext, useState, useCallback } from "react";
import OfflineDialog from "../components/dialogs/OfflineDialog";

const OfflineContext = createContext(null);

/**
 * Provider that manages the offline dialog state globally.
 * Wrap your app with this provider to enable showing the offline dialog
 * from anywhere (e.g., from the API client when a network error occurs).
 */
export const OfflineProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  const showOfflineDialog = useCallback(() => {
    setOpen(true);
  }, []);

  const hideOfflineDialog = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <OfflineContext.Provider value={{ showOfflineDialog, hideOfflineDialog }}>
      {children}
      <OfflineDialog open={open} onClose={hideOfflineDialog} />
    </OfflineContext.Provider>
  );
};

/**
 * Hook to access the offline dialog functions.
 * Call `showOfflineDialog()` to display the dialog (e.g., on network error).
 */
export const useOfflineDialog = () => {
  const context = useContext(OfflineContext);
  if (!context) {
    throw new Error("useOfflineDialog must be used within an OfflineProvider");
  }
  return context;
};

export default OfflineContext;
